// MyIcon.js
import React from 'react';
import myImage from '../images/DriveIcon.png';

const DriveIcon = () => {
  return <img src={myImage} alt="icon" style={{ width: 16, height: 16 ,alignItems:'center',alignContent:"center",justifyContent:'center',display:'flex'}} />;
};

export default DriveIcon;
